// extracted by mini-css-extract-plugin
module.exports = {"copy":"_2J1Aa-"};